import localforage from "localforage";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import useAuthentication from "./useAuthentication";

export default function usePrivateRoute() {
  const { currentUser } = useAuthentication();
  const history = useHistory();

  useEffect(() => {
    if (!currentUser) {
      window.localStorage.clear();
      localforage.clear();
      history.push("/authentication");
    }
  });
}
